import type { FC } from 'react';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

const TrendsNetworkFilter: FC = () => (
  <ToggleButtonGroup exclusive size="small" value="reddit" aria-label="Network">
    <ToggleButton value="reddit" sx={{ gap: 0.75 }}>
      <Box
        component="svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        sx={{ width: 16, height: 16, flexShrink: 0 }}
        aria-hidden="true"
      >
        <circle cx="10" cy="10" r="10" fill="#FF4500" />
        <path
          fill="#fff"
          d="M16.67 10a1.46 1.46 0 0 0-2.47-1 7.12 7.12 0 0 0-3.85-1.23l.65-3.07 2.13.45a1 1 0 1 0 1-.97 1 1 0 0 0-.96.66l-2.38-.5a.16.16 0 0 0-.19.12l-.73 3.43a7.14 7.14 0 0 0-3.89 1.23 1.46 1.46 0 1 0-1.61 2.39 2.9 2.9 0 0 0 0 .44c0 2.24 2.61 4.06 5.83 4.06s5.83-1.82 5.83-4.06a2.9 2.9 0 0 0 0-.44 1.46 1.46 0 0 0 .64-1.51zm-9.6 1.08a1 1 0 1 1 1 1 1 1 0 0 1-1-1zm5.56 2.64a3.56 3.56 0 0 1-2.63.86 3.56 3.56 0 0 1-2.63-.86.17.17 0 0 1 .24-.24 3.23 3.23 0 0 0 2.39.73 3.23 3.23 0 0 0 2.39-.73.17.17 0 0 1 .24.24zm-.17-1.64a1 1 0 1 1 1-1 1 1 0 0 1-1 1z"
        />
      </Box>
      Reddit
    </ToggleButton>
  </ToggleButtonGroup>
);

export default TrendsNetworkFilter;
